export const NAV = {
  logo: "nav-logo",
  loginBtn: "nav-login-btn",
  signupBtn: "nav-signup-btn",
  dashboardBtn: "nav-dashboard-btn",
  logoutBtn: "nav-logout-btn",
};

export const LANDING = {
  heroCta: "hero-cta-btn",
  heroSecondaryCta: "hero-secondary-cta-btn",
  pricingCta: "pricing-cta-btn",
  featureCard: (id) => `feature-card-${id}`,
};

export const AUTH_IDS = {
  loginForm: "login-form",
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-btn",
  registerForm: "register-form",
  registerName: "register-name-input",
  registerVenueName: "register-venue-name-input",
  registerEmail: "register-email-input",
  registerPassword: "register-password-input",
  registerSubmit: "register-submit-btn",
  error: "auth-error",
};

export const DASHBOARD = {
  root: "dashboard-root",
  statCard: (k) => `stat-${k}`,
  createEventBtn: "create-event-btn",
  eventRow: (id) => `event-row-${id}`,
  eventEditBtn: (id) => `event-edit-${id}`,
  eventPublicLink: (id) => `event-public-${id}`,
  navOverview: "dash-nav-overview",
  navEvents: "dash-nav-events",
  navOrders: "dash-nav-orders",
  navSettings: "dash-nav-settings",
  navBilling: "dash-nav-billing",
};

export const EVENT_FORM = {
  title: "event-title-input",
  description: "event-desc-input",
  location: "event-location-input",
  imageUpload: "event-image-upload",
  startAt: "event-start-input",
  endAt: "event-end-input",
  salesStartAt: "event-sales-start-input",
  salesEndAt: "event-sales-end-input",
  accessCode: "event-access-code-input",
  recurring: "event-recurring-switch",
  recurrenceRule: "event-recurrence-rule",
  recurrenceCount: "event-recurrence-count",
  addTier: "event-add-tier-btn",
  tierName: (i) => `tier-name-${i}`,
  tierPrice: (i) => `tier-price-${i}`,
  tierQty: (i) => `tier-qty-${i}`,
  tierRemove: (i) => `tier-remove-${i}`,
  addDiscount: "event-add-discount-btn",
  discountCode: (i) => `discount-code-${i}`,
  discountKind: (i) => `discount-kind-${i}`,
  discountAmount: (i) => `discount-amount-${i}`,
  discountMaxUses: (i) => `discount-max-uses-${i}`,
  discountRemove: (i) => `discount-remove-${i}`,
  addQuestion: "event-add-question-btn",
  questionLabel: (i) => `question-label-${i}`,
  questionType: (i) => `question-type-${i}`,
  questionRequired: (i) => `question-required-${i}`,
  questionOptions: (i) => `question-options-${i}`,
  questionRemove: (i) => `question-remove-${i}`,
  saveDraft: "event-save-draft-btn",
  publish: "event-publish-btn",
  statusSelect: "event-status-select",
  occurrenceRow: (id) => `occurrence-row-${id}`,
};

export const PUBLIC_EVENT_EXTRA = {
  accessCodeInput: "public-access-code-input",
  accessCodeSubmit: "public-access-code-submit",
  accessCodeError: "public-access-code-error",
  discountInput: "public-discount-input",
  discountApply: "public-discount-apply",
  discountApplied: "public-discount-applied",
  discountRemove: "public-discount-remove",
  answer: (id) => `public-answer-${id}`,
  saleClosedBanner: "public-sale-closed",
};

export const SETTINGS = {
  venueName: "settings-venue-name",
  brandColor: "settings-brand-color",
  logoUrl: "settings-logo-url",
  description: "settings-description",
  contactEmail: "settings-contact-email",
  website: "settings-website",
  customDomain: "settings-custom-domain",
  save: "settings-save-btn",
  stripeConnectBtn: "stripe-connect-btn",
  stripeRefreshBtn: "stripe-refresh-btn",
};

export const BILLING = {
  subscribeBtn: "billing-subscribe-btn",
  status: "billing-status",
};

export const PUBLIC_EVENT = {
  root: "public-event-root",
  venueHeader: "public-venue-header",
  buyBtn: "public-buy-btn",
  tierRow: (id) => `public-tier-${id}`,
  qtyInc: (id) => `public-qty-inc-${id}`,
  qtyDec: (id) => `public-qty-dec-${id}`,
  qtyValue: (id) => `public-qty-val-${id}`,
  buyerEmail: "public-buyer-email",
  buyerName: "public-buyer-name",
  checkoutBtn: "public-checkout-btn",
};

export const SUCCESS = {
  root: "checkout-success-root",
  orderNumber: "checkout-order-number",
  ticket: (i) => `success-ticket-${i}`,
};
